import { UiRotatingImagesModel } from "../../models";

import { mock$AssetModel } from "./mock-asset";
import { mockUiImageModel, mockUiImageModelContent } from "./mock-ui-image";
export function mockUiRotatingImagesModel({
    id = "rotating-images-1234",
    type = "uiRotatingImages",
    locale = "en",
    content = mockUiRotatingImagesModelContent()
}: Partial<UiRotatingImagesModel> = {}): UiRotatingImagesModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiRotatingImagesModelContent = UiRotatingImagesModel["content"];

const viewDemoImages = [
    "map",
    "board",
    "calendar",
    "dash-cards",
    "table",
    "timeline"
];

export function mockUiRotatingImagesModelContent({
    entryTitle = "Rotating images demo",
    items = viewDemoImages.map((id) =>
        mockUiImageModel({
            id,
            content: mockUiImageModelContent({
                image: mock$AssetModel({
                    title: id,
                    url: `/ui-rotating-images/${id}.png`,
                    width: 1836,
                    height: 968
                })
            })
        })
    )
}: Partial<UiRotatingImagesModelContent> = {}): UiRotatingImagesModelContent {
    return {
        entryTitle,
        items
    };
}
